import React, { useEffect } from 'react';
import { useHydrated } from './hooks';
import CurrentPage from './CurrentPage';
import { Footer } from 'components/Footer';
import styles from './styles.scss';
import { BreadCrumbs } from 'components/Shared/BreadCrumbs';
import ErrorModal from 'components/ErrorModal';
import { HeaderView } from 'components/Header';
import connect from 'components/Shared/connect';
import { isCleanView, getPageTopContentArea } from './selector';
import { ContentArea as ContentAreaModel } from 'models/ContentArea';
import { ContentArea } from 'components/Shared/Markdown';
import { isContentPage } from 'models/ContentPageModel';
import Notification from 'components/Notification';
import { isLegacy } from 'utils';
import {
  getSitewideAlerts,
  getSiteWideWithoutProductPageAlerts
} from 'components/AlertNotification/selector';
import { SitewideAlertNotifications } from 'components/AlertNotification';
import { AlertNotification as AlertNotificationModel } from 'models/AlertNotification';
import { isCheckoutPage } from 'models/CheckoutPageModel';
import { isMobile } from 'components/Shared/responsive';
import { ScrollToContent } from './ScrollToContent';
import { Loader } from 'components/loader';
import { isProductPage } from 'models/ProductPageModel';
import { isPpiPage } from 'models/PpiPageModel';

const PORTAL_HOVER = 'PORTAL_HOVER';
const PORTAL_DRAWER = 'PORTAL_DRAWER';

export const getDrawerContainer = () => document.getElementById(PORTAL_DRAWER);
export const getHoverContainer = () => document.getElementById(PORTAL_HOVER);

interface MergedProps {
  cleanView: boolean;
  pageTopContentArea: ContentAreaModel;
  isContentPage: boolean;
  isProductListPage: boolean;
  isProductPage: boolean;
  isEditorialPage: boolean;
  isSearchProductListPage: boolean;
  isFavouritesPage: boolean;
  isInstallationPage: boolean;
  isCustomerPage: boolean;
  channel: string;
  experiments: [string, number][];
  componentName: string;
  isCheckoutPage: boolean;
  isPpiPage: boolean;
  sitewideAlerts: AlertNotificationModel[];
  sitewideWithoutProductPageAlerts: AlertNotificationModel[];
  isMobile: boolean;
}

const CLEAN_VIEW_CLASSNAME = 'cleanView';
const BLANK_CLASSNAME = 'blank';
const GREY_CLASSNAME = 'grey';

export const PageLayout = connect<MergedProps>(state => ({
  cleanView: isCleanView(state),
  isContentPage: isContentPage(state.currentPage),
  pageTopContentArea: getPageTopContentArea(state.currentPage),
  channel: state.appShell.channel,
  componentName: state.currentPage.componentName,
  sitewideAlerts: getSitewideAlerts(state),
  sitewideWithoutProductPageAlerts: getSiteWideWithoutProductPageAlerts(state),
  isCheckoutPage: isCheckoutPage(state.currentPage),
  isProductPage: isProductPage(state.currentPage),
  isPpiPage: isPpiPage(state.currentPage),
  isMobile: isMobile(state)
}))(function Page({
  cleanView,
  isContentPage,
  pageTopContentArea,
  channel,
  componentName,
  sitewideAlerts,
  sitewideWithoutProductPageAlerts,
  isCheckoutPage,
  isProductPage,
  isPpiPage,
  isMobile
}: MergedProps) {
  useHydrated();
  useEffect(() => {
    cleanView
      ? document.body.classList.add(CLEAN_VIEW_CLASSNAME)
      : document.body.classList.remove(CLEAN_VIEW_CLASSNAME);

    !isLegacy({ channel, componentName }) || isMobile
      ? document.body.classList.add(BLANK_CLASSNAME)
      : document.body.classList.remove(BLANK_CLASSNAME);

    if (channel === 'PP') {
      document.body.classList.add(GREY_CLASSNAME);
    }
  }, [cleanView, isContentPage, componentName, isMobile, channel]);

  return (
    <>
      <Loader />
      <ScrollToContent />
      {!cleanView && <HeaderView />}
      <div className={styles.base}>
        {pageTopContentArea && <ContentArea {...pageTopContentArea} />}
        {!isCheckoutPage && !isPpiPage && <SitewideAlertNotifications alerts={sitewideAlerts} />}
        {!isProductPage && !isCheckoutPage && !isPpiPage && (
          <SitewideAlertNotifications alerts={sitewideWithoutProductPageAlerts} />
        )}
        {!cleanView && <BreadCrumbs />}
        <main id="mca">
          <CurrentPage />
        </main>
        {!cleanView && <Footer />}
        <div id={PORTAL_HOVER} />
        <div id={PORTAL_DRAWER} />
        <ErrorModal />
        <Notification />
      </div>
    </>
  );
});
